import { Button, Stack, Typography, useTheme } from "@mui/material";
import { Bell } from "lucide-react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	onAdd: () => void;
};

export const ReminderEmptyState = ({ onAdd }: Props) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Stack alignItems="center" gap={1.6} py={2}>
			<Bell size={32} color={theme.palette.grey[400]} />
			<Typography variant="body1" color={theme.palette.grey[500]}>
				{t(Resources.Reminders.Section.emptyTitle)}
			</Typography>
			<Button onClick={onAdd}>
				{t(Resources.Reminders.Section.addButton)}
			</Button>
		</Stack>
	);
};
